import React, { useCallback, useLayoutEffect, useRef, useState } from 'react';
import { ArranAbilityStealFlyOverlay } from './ArranAbilityStealFlyOverlay';

/**
 * Flies stolen abilities from source unit to Arr'an one after another.
 */
export const ArranAbilityStealFlyBatchOverlay = ({
  grant,
  onComplete,
}) => {
  const [stepIndex, setStepIndex] = useState(0);
  const onCompleteRef = useRef(onComplete);
  const batchFinishedRef = useRef(false);

  useLayoutEffect(() => {
    onCompleteRef.current = onComplete;
  }, [onComplete]);

  const batchGrants = grant?.batchGrants;
  const currentGrant = batchGrants?.[stepIndex];

  const handleStepComplete = useCallback(() => {
    if (!batchGrants?.length) {
      return;
    }
    setStepIndex((prev) => {
      if (prev + 1 >= batchGrants.length) {
        if (!batchFinishedRef.current) {
          batchFinishedRef.current = true;
          onCompleteRef.current?.();
        }
        return prev;
      }
      return prev + 1;
    });
  }, [batchGrants]);

  if (!grant || !batchGrants?.length || !currentGrant) {
    return null;
  }

  return (
    <ArranAbilityStealFlyOverlay
      key={`${grant.key}-step-${stepIndex}-${currentGrant.abilityName}`}
      grant={currentGrant}
      abilityName={currentGrant.abilityName}
      onComplete={handleStepComplete}
    />
  );
};

export default ArranAbilityStealFlyBatchOverlay;
